import { useState, useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PublicNavbar from './PublicNavbar';
import PublicFooter from './PublicFooter';
import BottomNav from './BottomNav';
import InstallPrompt from '../ui/InstallPrompt';

export default function PublicLayout() {
  const location = useLocation();
  const isDiscover = location.pathname === '/discover';
  const hideFooter = isDiscover;

  // Scroll-based BottomNav visibility for discover page
  const [showNav, setShowNav] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    if (!isDiscover) return;
    const handleScroll = () => {
      const currentY = window.scrollY;
      setShowNav(currentY < lastScrollY.current || currentY < 50);
      lastScrollY.current = currentY;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDiscover]);

  return (
    <div className="min-h-screen bg-midnight-bg flex flex-col">
      <PublicNavbar />
      <main className={`flex-1 pt-16 ${isDiscover ? 'pb-20 lg:pb-0' : ''}`}>
        <Outlet />
      </main>
      {!hideFooter && <PublicFooter />}
      {isDiscover && (
        <div className={`lg:hidden transition-transform duration-300 ${showNav ? 'translate-y-0' : 'translate-y-full'}`}>
          <BottomNav />
        </div>
      )}
      <InstallPrompt />
    </div>
  );
}
